import React, { forwardRef, useState, useMemo } from "react";

type TProps = {
  label?: string;
  value: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onMouseUp?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const Input = forwardRef<HTMLInputElement, TProps>(function Input(
  { label, value, onChange, className = "", placeholder, disabled, onFocus, onClick, onMouseUp, onBlur, onKeyUp },
  ref
) {
  const [isFocused, setIsFocused] = useState(false);

  const isExpanded = useMemo(() => {
    return isFocused || value.length > 0;
  }, [isFocused, value.length]);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  }

  return (
    <div className={`vitrine-template8__input ${isExpanded ? '--expanded' : ''} ${className}`}>
      <div className="vitrine-template8__input__wrapper">
        <label className={`vitrine-template8__input__label ${isExpanded ? '--expanded' : ''}`}>
          {label}
        </label>
        <input
          ref={ref}
          className={`vitrine-template8__input__field ${isExpanded ? '--expanded' : ''}`}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={handleFocus}
          onClick={onClick}
          onMouseUp={onMouseUp}
          onKeyUp={onKeyUp}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
});

Input.displayName = "Input";

export default Input;